import { render, staticRenderFns } from "./dataFormAdmin.vue?vue&type=template&id=27422941&scoped=true"
import script from "./dataFormAdmin.vue?vue&type=script&lang=js"
export * from "./dataFormAdmin.vue?vue&type=script&lang=js"
import style0 from "./dataFormAdmin.vue?vue&type=style&index=0&id=27422941&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27422941",
  null
  
)

export default component.exports